import React from 'react';
import img1 from '../../../images/react.png'
import img2 from '../../../images/props.jpg'
import img3 from '../../../images/crud.jpg'

const Blogs = () => {
    return (
        <div id="blogs">
            <div className='container'>
                <h2 className='text-color my-4'>My Latest Blogs</h2>

                <div className="container overflow-hidden text-start">
                    <div className="row gy-5">
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className="card bg-color p-4 border-success">
                                <img src={img1} className="card-img-top pb-4" alt="..." />
                                <div>
                                    <h5 className="card-title">React Component Lifecycle</h5>
                                    <p className="card-text" style={{ fontFamily: "open sans", fontSize: "14px", lineHeight: "1.5rem" }}>Every React Component has a lifecycle of its own, lifecycle of a component can be defined as the series of methods that are invoked in their component.</p>
                                    <a href="/home/#blogs" className="btn btn-outline-success btn-sm px-3">Blogs are coming soon.</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className="card bg-color p-4 border-success">
                                <img src={img2} className="card-img-top pb-4" alt="..." />
                                <div>
                                    <h5 className="card-title">State and props in JavaScript</h5>
                                    <p className="card-text" style={{ fontFamily: "open sans", fontSize: "14px", lineHeight: "1.5rem" }}>Props and state are two different terms that are often used interchangeably. They are both used to create a component or view in React.</p>
                                    <a href="/home/#blogs" className="btn btn-outline-success btn-sm px-3">Blogs are coming soon.</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className="card bg-color p-4 border-success">
                                <img src={img3} className="card-img-top pb-4" alt="..." />
                                <div>
                                    <h5 className="card-title">Explore MongoDB Crud Operation</h5>
                                    <p className="card-text" style={{ fontFamily: "open sans", fontSize: "14px", lineHeight: "1.5rem" }}>CRUD (create, read, update and delete) is an acronym that refers to the four functions that are necessary to implement a persistent storage application.</p>
                                    <a href="/home/#blogs" className="btn btn-outline-success btn-sm px-3">Blogs are coming soon.</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blogs;